const schema = {
  en: "English",
  // ru: "Русский",
  pt: "Português",
  // kk: "Қазақша",
  ar: "العربية",
  tr: "Türk",
  de: "Deutsch",
  it: "Italiano",
  es: "Español",
  // fr: "Français",
};

export const findLanguage = (code) => {
  return schema[code];
};

export const rememberLocale = (locale) => {
  localStorage.setItem("locale", locale);
};
